export const metadataDefaults = {
    ko: [
        'Nava Insights 연구에 초대되었습니다',
        'Nava Insights의 AI 인터뷰에서 경험을 공유해 주세요.',
        'Clair와의 대화에 초대되었습니다',
        'Clair와의 대화에서 경험을 공유해 주세요.',
    ],
    en: [
        "You're invited to a study with Nava Insights",
        'Share your voice in an AI-powered research interview by Nava Insights.',
        "You're invited to a conversation with Clair",
        'Share your experience in a conversation with Clair.',
    ],
    sv: [
        'Du är inbjuden till en studie med Nava Insights',
        'Dela dina erfarenheter i en AI-intervju med Nava Insights.',
        'Du är inbjuden till ett samtal med Clair',
        'Dela dina erfarenheter i ett samtal med Clair.',
    ],
    da: [
        'Du er inviteret til en undersøgelse med Nava Insights',
        'Del dine erfaringer i et AI-interview med Nava Insights.',
        'Du er inviteret til en samtale med Clair',
        'Del dine erfaringer i en samtale med Clair.',
    ],
    no: [
        'Du er invitert til en studie med Nava Insights',
        'Del dine erfaringer i et AI-intervju med Nava Insights.',
        'Du er invitert til en samtale med Clair',
        'Del erfaringene dine i en samtale med Clair.',
    ],
    fi: [
        'Sinut on kutsuttu tutkimukseen Nava Insights -palvelussa',
        'Jaa kokemuksesi Nava Insights -palvelun tekoälyhaastattelussa.',
        'Sinut on kutsuttu keskusteluun Clairin kanssa',
        'Jaa kokemuksesi keskustelussa Clairin kanssa.',
    ],
    de: [
        'Du bist zu einer Studie mit Nava Insights eingeladen',
        'Teile deine Erfahrungen in einem KI-Interview mit Nava Insights.',
        'Du bist zu einem Gespräch mit Clair eingeladen',
        'Teile deine Erfahrungen in einem Gespräch mit Clair.',
    ],
    nl: [
        'Je bent uitgenodigd voor een onderzoek met Nava Insights',
        'Deel je ervaringen in een AI-interview met Nava Insights.',
        'Je bent uitgenodigd voor een gesprek met Clair',
        'Deel je ervaringen tijdens een gesprek met Clair.',
    ],
    fr: [
        'Vous êtes invité à une étude avec Nava Insights',
        'Partagez votre expérience dans un entretien mené par une IA avec Nava Insights.',
        'Vous êtes invité à une conversation avec Clair',
        'Partagez votre expérience lors d’une conversation avec Clair.',
    ],
    es: [
        'Te invitamos a un estudio con Nava Insights',
        'Comparte tu experiencia en una entrevista con IA de Nava Insights.',
        'Te invitamos a una conversación con Clair',
        'Comparte tu experiencia en una conversación con Clair.',
    ],
    it: [
        'Sei invitato a uno studio con Nava Insights',
        'Condividi la tua esperienza in un’intervista con IA di Nava Insights.',
        'Ti invitiamo a una conversazione con Clair',
        'Condividi la tua esperienza in una conversazione con Clair.',
    ],
    pt: [
        'Você foi convidado para um estudo com Nava Insights',
        'Compartilhe sua experiência em uma entrevista com IA da Nava Insights.',
        'Recebeste um convite para uma conversa com a Clair',
        'Partilha a tua experiência numa conversa com a Clair.',
    ],
    pl: [
        'Zapraszamy do badania z Nava Insights',
        'Podziel się doświadczeniami w wywiadzie z AI prowadzonym przez Nava Insights.',
        'Zapraszamy na rozmowę z Clair',
        'Podziel się opinią podczas rozmowy z Clair.',
    ],
    cs: [
        'Zveme vás do studie s Nava Insights',
        'Podělte se o své zkušenosti v rozhovoru s AI od Nava Insights.',
        'Zveme vás na rozhovor s Clair',
        'Podělte se o své zkušenosti v rozhovoru s Clair.',
    ],
};
//# sourceMappingURL=metadataDefaults.js.map